import { Children, type HTMLAttributes } from 'react';
import { StyledDataList } from './DataList.styles';

export interface DataListProps extends HTMLAttributes<HTMLDivElement> {}

const DataList = ({ children }: DataListProps) => {
  return (
    <StyledDataList rowCount={Children.count(children)}>
      {children}
    </StyledDataList>
  );
};

export default DataList;
